import React from 'react';

import { DevicesViewColumns, DeviceType } from 'utils/constant';
import EditCollectionView from '../../common/EditCollectionView';
import DevicesView from '../DevicesView';

const TrailersPage = () => {
    return (
        <EditCollectionView 
            content={DevicesView} 
            forceNoLimit={true}
            editPath="trailer" 
            endpoint="devices" 
            type={DeviceType.TRAILER}
            columns={[
                DevicesViewColumns.LABEL,
                DevicesViewColumns.TRACKER_IDENTIFIER,
                DevicesViewColumns.BRAND,
                DevicesViewColumns.MODEL,
                DevicesViewColumns.GROUP,
            ]}
        />
    );
}

export default TrailersPage;